import React from 'react';
import { Title } from './Titulo.style';

const Titulo = (props) => {
    return <Title>{props.titulo}</Title>;
};

export default Titulo;
